import * as React from 'react';
import * as styles from './styles.css';

import HumanSvg from '../assets/human_bg.svg';
import MetroSvg from '../assets/metro.svg';
import MoneySvg from '../assets/money.svg';
import PercentSvg from '../assets/percent.svg';

import { UIHeading2, UIHeading3, UIText1, UIText2, Button, Image } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import { ConditionalWrapper } from '@cian/conditional-component';

export interface IOnbordingBannerProps {
  isDesktop: boolean;
  onStartOnbording(): void;
  onCloseOnbording(): void;
}

export const OnbordingBanner: React.FC<IOnbordingBannerProps> = ({ isDesktop, onStartOnbording, onCloseOnbording }) => {
  return (
    <div data-testid="OnbordingBanner" className={styles['container']}>
      <div className={styles['bg_img_human']}>
        <Image src={HumanSvg} />
      </div>
      <div className={styles['bg_img_metro']}>
        <Image src={MetroSvg} />
      </div>
      <div className={styles['bg_img_money']}>
        <Image src={MoneySvg} />
      </div>
      <div className={styles['bg_img_percent']}>
        <Image src={PercentSvg} />
      </div>
      <button data-testid="OnbordingBanner_Close" type="button" className={styles['close']} onClick={onCloseOnbording}>
        <IconActionClose12 color="icon-primary-default" />
      </button>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading2} ElseComponent={UIHeading3}>
          Что есть в отчёте
        </ConditionalWrapper>
      </div>
      <div className={styles['description']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIText1} ElseComponent={UIText2}>
          Рассказываем, из чего он состоит и что это значит
        </ConditionalWrapper>
      </div>
      <Button theme="fill_primary" size="M" onClick={onStartOnbording}>
        Подробнее
      </Button>
    </div>
  );
};

OnbordingBanner.displayName = 'OnbordingBanner';
